import { render, staticRenderFns } from "./TableModals.vue?vue&type=template&id=a6e3f944&scoped=true&lang=pug&"
import script from "./TableModals.vue?vue&type=script&lang=ts&"
export * from "./TableModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e3f944",
  null
  
)

export default component.exports